export const htmlFile = `
<section class="bg-blue-50" id="contact">
    <div class="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-12">
        <div class="mb-4">
            <div class="mb-6 max-w-3xl text-center sm:text-center md:mx-auto md:mb-12">
                <p class="text-base font-semibold uppercase tracking-wide text-blue-600">
                    Contact
                </p>
                <h2
                    class="font-heading mb-4 font-bold tracking-tight text-gray-900 text-3xl sm:text-5xl">
                    Formulaire de contact
                </h2>
                <p class="mx-auto mt-4 max-w-3xl text-xl text-gray-600">
                    Bienvenue sur la création de formulaire !
                </p>
            </div>
        </div>
        <div class="flex items-stretch justify-center">
            <div class="grid md:grid-cols-2">
                <div class="h-full pr-6">
                    <p class="mt-3 mb-12 text-lg text-gray-600">
                        Vous pouvez <b>glisser-déposer</b> des blocs par le côté droit. <br />
                        Modifier le formulaire en <b>cliquant dessus</b>.
                        <br />
                        Pour les développeurs, nous utilisons <b>TailWind CSS</b> pour faciliter la création dans cet éditeur.
                    </p>
                    <ul class="mb-6 md:mb-0">
                        <li class="flex">
                            <div class="flex h-10 w-10 items-center justify-center rounded bg-blue-900 text-gray-50">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="h-6 w-6">
                                    <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                                    <path
                                        d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z">
                                    </path>
                                </svg>
                            </div>
                            <div class="ml-4 mb-4">
                                <h3 class="mb-2 text-lg font-medium leading-6 text-gray-900">Notre adresse
                                </h3>
                                <p class="text-gray-600">Rue du 1234, Lieu</p>
                                <p class="text-gray-600">Paris, France</p>
                            </div>
                        </li>
                        <li class="flex">
                            <div class="flex h-10 w-10 items-center justify-center rounded bg-blue-900 text-gray-50">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="h-6 w-6">
                                    <path
                                        d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2">
                                    </path>
                                    <path d="M15 7a2 2 0 0 1 2 2"></path>
                                    <path d="M15 3a6 6 0 0 1 6 6"></path>
                                </svg>
                            </div>
                            <div class="ml-4 mb-4">
                                <h3 class="mb-2 text-lg font-medium leading-6 text-gray-900">Contact
                                </h3>
                                <p class="text-gray-600">Mobile: +33 06 01 02 03 04</p>
                                <p class="text-gray-600">Mail: test@email.com</p>
                            </div>
                        </li>
                        <li class="flex">
                            <div class="flex h-10 w-10 items-center justify-center rounded bg-blue-900 text-gray-50">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="h-6 w-6">
                                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                                    <path d="M12 7v5l3 3"></path>
                                </svg>
                            </div>
                            <div class="ml-4 mb-4">
                                <h3 class="mb-2 text-lg font-medium leading-6 text-gray-900">Heures d'ouverture</h3>
                                <p class="text-gray-600">Lundi - Vendredi: 08:00 - 17:00</p>
                                <p class="text-gray-600">Samedi &amp; Dimanche: 08:00 - 12:00</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="card h-full max-w-6xl p-5 md:p-12 md:pt-0">
                    <h2 class="mb-4 text-2xl font-bold">Nous contacter</h2>
                    
                    <form id="main-form" class="custom-form" name="Mon formulaire">
                        <div class="form-element">
                            <label for="field-3">
                            Nom <span class='required-indicator'>*</span>
                            </label>
                            <input class="form-input" name="%last_name%" id="field-3" type="text" required placeholder="John Doe" />
                        </div>
                        <div class="form-element">
                            <label for="field-1">
                            Email <span class='required-indicator'>*</span>
                            </label>
                            <input class="form-input" name="%email%" id="field-1" type="text" required
                            placeholder="example@domain.ltd" />
                        </div>
                        <div class="form-element">
                            <label for="field-6">
                            Téléphone <span class='required-indicator'>*</span>
                            </label>
                            <input class="form-input" name="%phone%" id="field-6" type="text" required
                            placeholder="+33 0 00 00 00" />
                        </div>
                        <div class="form-element">
                            <label for="field-12">
                            Entreprise <span class='required-indicator'>*</span>
                            </label>
                            <input class="form-input" name="%company%" id="field-12" type="text" required
                            placeholder="Company Ltd." />
                        </div>
                        <button type="submit" class="submit-button">Envoyer</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
`;
